<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="1200" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-title primary-title>
          <b class="mr-2"> {{ $t("upload.text1") }}: </b>
          {{ _detail.ConsentShort }}
        </v-card-title>
        <v-card-text>
          <v-card outlined>
            <v-card-title>{{ $t("upload.text4") }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="_detail.ConsentDetail"></div>
            </v-card-text>
          </v-card>
          <br />
          <v-card outlined>
            <v-card-title>{{ $t("upload.text5") }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="_detail.RejectReason"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">
            {{ $t("consentform.off") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_header", "_detail"],
  data: function () {
    return {};
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogDelete");
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("closeDialogDelete");
    },
  },
};
</script>
